// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3ZuLd","newExpiryDate":"styles_newExpiryDate__1wTcB","footer":"styles_footer__3n4Gt"};